import React from "react";
import { OneTileDynamicZoneModel } from "@models/strapi-components/tile-wrapper";
import { twMerge } from "tailwind-merge";
import Title from "./Title";

export interface TilePropsModel {
  data: Partial<OneTileDynamicZoneModel>;
  wrapperClassName?: string;
  titleClassName?: string;
  iconClassName?: string;
  subTitleClasName?: string;
}
const Tile: React.FunctionComponent<TilePropsModel> = ({
  data,
  wrapperClassName,
  titleClassName,
  subTitleClasName,
}) => {
  const { title, subTitle } = data;
  return (
    <div
      className={twMerge("p-8 rounded-2xl grow-0 bg-white", wrapperClassName)}
      style={{
        boxShadow: `0px 20px 40px 0px rgba(0, 0, 0, 0.07)`,
      }}
    >
      {title && (
        <Title
          variant="primary"
          titleText={title}
          className={twMerge("text-left", titleClassName)}
        />
      )}
      {subTitle && (
        <Title
          variant="paragraph"
          titleText={subTitle}
          className={twMerge("text-left", subTitleClasName)}
        />
      )}
    </div>
  );
};

export default Tile;
